export const RBAC_ACTIONS = {
  READ: 'READ',
  READ_WRITE: 'READ_WRITE',
  DOWNLOADS: 'DOWNLOADS'
}
